import { AppStates } from '../states';

export const selectOpened = (state: AppStates) => state.sideNavState.opened;

